import { Toggle } from "./ResultsComponents"
export default function GeneralCustomization({
  resultData = {},
  onUpdate
}){
  // Extract values from resultData or fallback to false
  const review = resultData.admin_approval ?? false;
  const preview = resultData.teacher_preview ?? false;
  //const customize = resultData.customize ?? false;

  return(
    <div>
      <div className="flex justify-between gap-2 my-10">
        <p className="font-semibold">Enable preview option for teachers</p>
        <div className="w-6">
          <Toggle toggle={preview} setToggle={val => onUpdate && onUpdate('teacher_preview', val)}/>
        </div>
      </div>

      <div className="flex justify-between gap-2 my-10">
        <p className="font-semibold">Admin must approve all results</p>
        <div className="w-6">
          <Toggle toggle={review} setToggle={val => onUpdate && onUpdate('admin_approval', val)}/>
        </div>
      </div>

      {/*<div className="flex justify-between gap-2 my-10">
        <p className="font-semibold">Teachers should customize result format (e.g CA weight adjustment)</p>
        <div className="w-6">
          <Toggle toggle={customize} setToggle={val => onUpdate && onUpdate('customize', val)}/>
        </div>
      </div>*/}
    </div>
  )
}